import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    padding: '32px',
  },
  removeTopPadding: {
    paddingTop: 0,
  },
  closeIcon: {
    color: 'common.grey350',
    backgroundColor: 'common.lightBackgroundColor',
  },
  rowContainer: {
    display: 'flex',
    border: '0.5px solid',
    borderBottom: '1px solid',
    padding: '13px',
    borderColor: 'common.border',
  },
  button: {
    backgroundColor: 'common.lightGreen',
    color: 'primary.main',
    '&:hover': {
      backgroundColor: 'common.lightGreen',
    },
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: 24,
    fontWeight: '600',
    color: 'common.grey800',
  },
  description: {
    fontSize: 14,
    color: 'grey.500',
    mt: '6px',
    mb: '24px',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
